<template>
  <div v-if="appStore.isEmergencyPopupVisible && data.title" class="emergency-popup">
    <div class="popup__container emergency-popup__container container">
      <div class="emergency-popup__copy">
        <RichRenderer :richTextData="data.message" />
      </div>
      <i class="icon-close emergency-popup__close-icon" @click="closePopup" />
    </div>
  </div>
</template>
<script>
import { getCurrentInstance, ref } from 'vue'

import { useContentfulAutowireGlobal } from '@/components/common/contentful/composables/useContentfulAutowireGlobal'

import { useAppStore } from '@/stores/app'

export default {
  name: 'EmergencyPopup',
  setup() {
    const appStore = useAppStore()

    const data = ref({})
    const initData = (entry) => {
      data.value = { ...entry }
    }

    const instance = getCurrentInstance()
    const componentName = instance.type.name || ''
    useContentfulAutowireGlobal({
      componentName,
      customInitData: initData,
    })
    return {
      data,
      appStore,
    }
  },

  methods: {
    closePopup() {
      this.appStore.toggleEmergencyPopup(false)
    },
  },
}
</script>
